function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import ModalWithSignupComponent from "/components/core/modal-with-signup/modal-with-signup-component";
import YouTubeVideoComponent from "components/core/youtube-video/youtube-video-component";
import { StyledYoutubeVideoWrapper } from "./youtube-video-modal-component.scss";
class YoutubeVideoModalComponent extends PureComponent {
    render() {
        const { isOpen, onCloseModal, footerText, style, withSignup } = this.props;
        return /*#__PURE__*/ _jsx(ModalWithSignupComponent, {
            style: style,
            footerText: footerText,
            isOpen: isOpen,
            onCloseModal: onCloseModal,
            withSignup: withSignup,
            children: /*#__PURE__*/ _jsx(StyledYoutubeVideoWrapper, {
                className: "youtube-video-wrapper",
                children: /*#__PURE__*/ _jsx(YouTubeVideoComponent, _object_spread({}, this.props))
            })
        });
    }
}
export { YoutubeVideoModalComponent as default };
YoutubeVideoModalComponent.defaultProps = {
    withSignup: true
};
